import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./coupon_provider.js";
//#region src/coupon_provider_helper.ts
var coupon_provider_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(provider) {
	switch (provider) {
		case "none": return "No Provider";
		case "pos": return "POS";
		case "loyalty": return "Loyalty";
		case "bite": return "Bite";
	}
}
//#endregion
export { coupon_provider_helper_exports, name };

//# sourceMappingURL=coupon_provider_helper.js.map